/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {Partner as partnerSchema} from './partners';

export const Partner = partnerSchema;
export type IPartner = yup.InferType<typeof Partner>;
